import React from 'react'
import {EuiSpacer} from '@elastic/eui'

import ProductTable from '../../../components/Products/Compare/outdoor-compare-table'

import BreadCrumbs from '../../../components/Layout/BreadCrumbs'
import NavButtons from '../../../components/Products/NavButtons'

import SEOHelmet from '../../../components/Layout/SEOHelmet'


const seodata = {
  title: 'Alle INSTAR Aussenkamera Modelle Vergleichen',
  description: 'Alle INSTAR Aussenkamera Modelle Vergleichen.',
  image: '/images/Search/QI_SearchThumb_SetupWizard.png',
  twitter: '/images/Search/QI_SearchThumb_SetupWizard.webp',
  locationEN: 'https://wiki.instar.com/en/Products/Compare/Outdoor_Cameras/',
  locationDE: 'https://wiki.instar.com/de/Products/Produkte/Vergleich/Aussenkameras/',
  locationFR: 'https://wiki.instar.com/fr/Products/Compare/Outdoor_Cameras/'
}


const OutdoorCams = (props) => (
  <React.Fragment>

    <SEOHelmet
      title={seodata.title}
      description={seodata.description}
      image={seodata.image}
      location={props.location} />

    <BreadCrumbs
        locationBC={props.location}
        locationDE={props.location.pathname}
        locationEN='/en/Products/Compare/Outdoor_Cameras/'
        locationFR='/fr/Products/Compare/Outdoor_Cameras/'
        crumbLabel="Outdoor Camera" />
        
    <NavButtons />

    <h1>INSTAR Kamera Modelle Vergleichen</h1>

    <EuiSpacer />

    <ProductTable />
    
  </React.Fragment>
  )

export default OutdoorCams